import { Component } from '@angular/core';

@Component({
  selector: 'pty-partymgr',
  template: `
    <p>
      partymgr works!
    </p>
  `,
  styles: [
  ]
})
export class PartymgrComponent {

}
